import { Component } from '@angular/core';

@Component({
  selector: 'ui-panel-header',
  templateUrl: './panel-header.component.html',
  styleUrls: ['./panel-header.component.scss'],
})
export class PanelHeaderComponent {}
